import { render, staticRenderFns } from "./SellerStatistic.vue?vue&type=template&id=4d944086&scoped=true"
import script from "./SellerStatistic.vue?vue&type=script&lang=js"
export * from "./SellerStatistic.vue?vue&type=script&lang=js"
import style0 from "./SellerStatistic.vue?vue&type=style&index=0&id=4d944086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d944086",
  null
  
)

export default component.exports